/** Valida as informações do formulário e retorna um resultado */

/**
 * Valida as informações preenchidas pelo usuário
 * @param {Object} data - Informações do formulário
 * @return {Object} - Retorna sucesso ou erro
 */
function validateData(data) {
  const type = data.tipo_acordo;
  const valor_atualizado = data.valor_atualizado;
  const valor_acordo = data.valor_acordo;
  const valor_entrada = data.valor_entrada || 0;

  if (type == "Amigavel") {
    /** Caso o acordo é amigável, o valor do acordo não pode ser maior
     * que o valor original da dívida. */
    if (valor_acordo > valor_atualizado) {
      return {
        success: false,
        error: "O valor do acordo não pode ser maior que o valor original."
      };
    }
  }

  /** Validação das parcelas */
  const qntParcelas = parseInt(data.qnt_parcelas);

  let soma = 0;

  for (let i = 1; i <= qntParcelas; i++) {
    const valor_parc = data[`parcela_${i}`];

    /** Parcelas com o valor 0 */
    if (valor_parc <= 0) {
      return {
        success: false,
        error: "Existem parcelas com o valor 0,00. Verifique e tente novamente."
      };
    }

    soma += valor_parc;
  }

  console.log(soma);
  console.log(valor_acordo);
  console.log(soma - valor_acordo);
  if (soma.toFixed(2) > valor_acordo - valor_entrada) {
    return {
      success: false,
      error: "A soma das parcelas deve corresponder ao valor do acordo!"
    };
  }

  if (valor_acordo - valor_entrada - soma > 0.1) {
    return {
      success: false,
      error: "A soma das parcelas deve corresponder ao valor do acordo!"
    };
  }

  return { success: true, error: null };
}

export default validateData;



// WEBPACK FOOTER //
// ./src/pages/Acordo/Create/Validation/index.js